import Vue from 'vue'
import Router from 'vue-router'
import Root from '@/components/Root'
import Register from '@/components/Register'
import Login from '@/components/Login'
import Movies from '@/components/Movies'
import CreateMovie from '@/components/CreateMovie'
import EditMovie from '@/components/EditMovie'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: Root
    },
    {
      path: '/movies',
      name: 'movies',
      component: Movies
    },
    {
      path: '/movies/create',
      name: 'movies-create',
      component: CreateMovie
    },
    {
      path: '/movies/edit',
      name: 'movies-edit',
      component: EditMovie
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js